var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row d-flex v-spacing-child-prj" }, [
    _c("div", { staticClass: "column d-flex flex-column@until-medium" }, [
      _c("div", {
        domProps: {
          innerHTML: _vm._s(
            _vm.versandaufteilungService.getConcatenatedAddress(
              _vm.address,
              "<br />"
            )
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "ml-auto@medium flex-child-fix d-flex flex-wrap justify-content-between@until-medium v-spacing-prj@until-medium gap-4 ml-2 align-items-center",
        },
        [
          _vm.showAddressBook
            ? _c(
                "a",
                {
                  staticClass:
                    "btn btn--dark w-75@until-medium mr-prj mr-2@large",
                  on: { click: _vm.openAddressModal },
                },
                [
                  _vm._v(
                    _vm._s(_vm._f("translate")("versandaufteilungAddressbuch"))
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-row gap-2" }, [
            _vm.address.addressinfoid <= 0
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn--link p-0",
                    attrs: {
                      title: _vm._f("translate")("versandaufteilungAnpassen"),
                    },
                    on: { click: _vm.openTextAddressModal },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "svg-icon svg-icon--large",
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c(
                          "g",
                          { attrs: { "clip-path": "url(#clip0_32_2115)" } },
                          [
                            _c("path", {
                              attrs: {
                                d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
                                fill: "#3A3A39",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M7.54167 16.4583H8.53333L14.6427 10.3489L13.651 9.35725L7.54167 15.4666V16.4583ZM17.6708 9.32183L14.6604 6.34683L15.6521 5.35517C15.9236 5.08364 16.2572 4.94788 16.653 4.94788C17.0482 4.94788 17.3816 5.08364 17.6531 5.35517L18.6448 6.34683C18.9163 6.61836 19.058 6.94608 19.0698 7.33C19.0816 7.71345 18.9517 8.04093 18.6802 8.31246L17.6708 9.32183ZM6.83333 17.875C6.63264 17.875 6.46453 17.807 6.329 17.671C6.193 17.5354 6.125 17.3673 6.125 17.1666V15.1656C6.125 15.0711 6.14271 14.9798 6.17813 14.8915C6.21354 14.8027 6.26667 14.7229 6.3375 14.652L13.6333 7.35621L16.6438 10.3666L9.34792 17.6625C9.27708 17.7333 9.19751 17.7864 9.10921 17.8218C9.02043 17.8573 8.92882 17.875 8.83437 17.875H6.83333ZM14.1469 9.85308L13.651 9.35725L14.6427 10.3489L14.1469 9.85308Z",
                                fill: "#0095D2",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("defs", [
                          _c("clipPath", { attrs: { id: "clip0_32_2115" } }, [
                            _c("rect", {
                              attrs: {
                                width: "24",
                                height: "24",
                                fill: "white",
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canRemoveAddress
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn--link p-0",
                    attrs: { title: _vm._f("translate")("txtDeleteAddress") },
                    on: {
                      click: function ($event) {
                        return _vm.versandaufteilungService.removeAddress(
                          _vm.index
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "svg-icon svg-icon--large",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 36 36",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "18",
                            cy: "18",
                            r: "18",
                            fill: "#3a3a39",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M24.92 23.33L19.59 18l5.32-5.32c.44-.44.44-1.15 0-1.59-.44-.44-1.15-.44-1.59 0L18 16.41l-5.32-5.32c-.44-.44-1.15-.44-1.59 0-.44.44-.44 1.15 0 1.59L16.41 18l-5.32 5.32c-.44.44-.44 1.15 0 1.59.44.44 1.15.44 1.59 0L18 19.59l5.33 5.33c.44.44 1.15.44 1.59 0s.44-1.15 0-1.59z",
                            fill: "#fff",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "hide-for-medium mb-prj mt-prj2" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }